import $ from 'jquery'
import User from '../classes/user'

var nextConfigTimeout;

export default class Card {
  constructor() {
    var that = this;

    $(document).bind('qa-bubble-show', function (e, data) {
      let qa = data.qa;

      //initializing result with 0
      if (qa.id === 0) {
        Card.result = 0;
      }

      $("#chessVideo")[0].currentTime = '227.5';

      $('#chessVideo').removeClass('show').addClass('hide');
      $('.chessboard-container').removeClass('show-flex').addClass('hide');
      $('.qa-section-container').removeClass('hide').addClass('show');

      if (qa.result) {
        that.displayResultModule(qa)
      } else {
        that.displayCard(qa)
      }

    }).bind(that)

    $(document).bind('qa-bubble-hide', function (e, data) {
      clearTimeout(nextConfigTimeout);
      that.hideCard()
    }).bind(that)
  }

  /**
  * @name displayCard
  * @function
  * @param {qa}
  * @description: Display the card
  */
  displayCard(qa) {
    let question = qa.question,
      answers = qa.answer,
      validateAnswer = qa.validateAnswer,
      isAssessment = qa.isAssessment,
      styleClass = qa.styleClass,
      rightAnswerTimeout = qa.rightAnswerTimeout;

    let body = `
      <div class="qa-section">
        <div class="qa-section-wrapper">
          <div class="header flex-center">
            <div class="question-container"><div class="question">${question}</div></div>   
          </div>
          <div class="body">
            <div class="answer-container full-height flex-horizontal-center">
              <span class="btn answer" data-answer='0'>${answers[0] ? answers[0] : 'N/A'}</span>
              <span class="btn answer" data-answer='1'>${answers[1] ? answers[1] : 'N/A'}</span>
              <span class="btn answer" data-answer='2'>${answers[2] ? answers[2] : 'N/A'}</span>
              <span class="btn answer" data-answer='3'>${answers[3] ? answers[3] : 'N/A'}</span> 
            </div>       
          </div>
        </div>
    </div>`;

    if (qa.chessboard) {
      $(document).trigger('chessBoard-show', qa.chessboard);
    }
    
    $('.qa-section-content').html(body);


    $('.answer').click(function () {
      let userAnswer = parseInt($(this).attr('data-answer'), 10),
        timeout = rightAnswerTimeout ? rightAnswerTimeout : 4000;

      if ($('.answer-container').find('.selected').length < 1) {
        $('.answer').removeClass('selected');
        $(this).addClass('selected');

        if (userAnswer === validateAnswer.rightAnswer || isAssessment) {
          Card.result = Card.result + 1;

          if (qa.highlightSquares) {
            setTimeout(function () {
              $(document).trigger('next-config');
            }, 4000)
          }
          else {
            setTimeout(function () {
              $(document).trigger('next-config');
            }, 1000)
          }
        } else {
          if (!qa.isAssessment) {
            $(document).trigger('bubble-show',
              {
                data: 'Oops...!!!<br/>The correct answer is "' + qa.rightAnswer + '"',
                position: 'left',
                styleClass: styleClass
              }
            );
          }
          setTimeout(function () {
            $(document).trigger('next-config');
          }, timeout)
        }
      }
    });
  }

  /**
  * @name hideCard
  * @function
  * @param {}
  * @description: Hide the card
  */
  hideCard() {
    $('.qa-section').remove();
    $('.hint-image-container').remove();
  }

  /**
  * @name displayResultModule
  * @function
  * @param {data}
  * @description: Display the score card
  */
  displayResultModule(data) {
    let userName = User.user.name,
      correctAnswers = Card.result,
      isAssessment = data.isPreAssessment,
      positiveMsg = 'Great work, ' + userName + '! <br/>You got ' + correctAnswers + '/10. <br/>Looks like you are <br/>ready for <br/>' + data.nextLesson + '!',
      negativeMsg = userName + ', you got ' + correctAnswers + '/10. <br/>You might want to <br/>practice a bit more <br/>before moving on to <br/>' + data.nextLesson + '!',
      positiveMsgLesson20 = 'Great work, ' + userName + '! <br/>You got ' + correctAnswers + '/10. <br/>Congratulations!!Well done.',
      negativeMsgLesson20 = userName + ', you got ' + correctAnswers + '/10. <br/>You might want to <br/>practice a bit more!',
      resultLesson20 = correctAnswers > 6 ? positiveMsgLesson20 : negativeMsgLesson20,
      message = 'You are done. Thanks for letting me know what you know!.',
      result = isAssessment ? message : correctAnswers > 6 ? positiveMsg : negativeMsg,
      qaTimeout = data.timeout;

 // Todo: Need to call Rest Api for progress 
    console.log('correctAnswers', correctAnswers);

    var postData = {
      id: User.getUser().id,
      username: userName,
      "lesson_id": User.getUser().currentLesson,
      "Score": correctAnswers
    };

    fetch("https://db.firstmovechess.org/student/lesson", {
      body: JSON.stringify(postData),
      method: "POST"
    })
    .then(response => response.json())
    .then(responseData => {
      if(window.ga){
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'Lesson Stats',
          eventAction: 'Lesson click',
          eventLabel: User.getUser().currentLesson
        });
      }
      console.log(responseData)
    });
      
    if (data.nextLesson !== 'None') {
      $(document).trigger('bubble-show',
        {
          data: result,
          position: data.position,
          styleClass: data.styleClass
        }
      );
    }
    else if (data.nextLesson === 'None') {
      $(document).trigger('bubble-show',
        {
          data: resultLesson20,
          position: data.position,
          styleClass: data.styleClass
        }
      );
    }

    if (qaTimeout) {
      nextConfigTimeout = setTimeout(function () {
        $(document).trigger('next-config');
      }, qaTimeout)
    }

  }
}

Card.result = 0;


// WEBPACK FOOTER //
// ./src/components/card.js